import React from "react";
import "./MissionStatement.css";


function MissionStatement() {
  return (
    <section className="mission-section bg-light py-5">
      <div className="container text-center px-4">
        <>
          <h2 className="fw-bold mb-4 anchor-adjust"  id="mission">Our Mission</h2>
          <p className="lead mx-auto" style={{ maxWidth: '700px' }}>
            <span className="highlighted-intro scroll-reveal">upself is on a mission to make mental health smarter, faster, and truly global.</span>
            <br /><br />
            Built by systems engineer and researcher Rodrigo Costa, our platform blends AI with graph theory
            to generate real-time psychological insights from over 3,800 curated items and 250+ dimensions.
            <br /><br />
            In partnership with <strong>Melhor Terapia</strong>, we’re scaling across Latin America — empowering
            therapists and platforms with multilingual, evidence-based insights.
          </p>
        </>
      </div>
    </section>
  );
}

export default MissionStatement;
